import { useNavigate } from "react-router-dom";
import Post from "./Post";
import { useContext, useEffect, useState } from "react";
import AuthContext from "../../Contexts/Auth/AuthContext";
import Loader from "../Loader";
import { Tooltip } from "react-tooltip";

const PostList = () => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const [response, setResponse] = useState({});
  const [deleteApiResponse, setDeleteApiResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(process.env.REACT_APP_EXPRESS_URL + "/posts", {
        headers: {
          Authorization: "Bearer " + authContext.token,
          "Content-Type": "application/json",
        },
        method: "GET",
      });

      if (!response.ok) {
        setResponse(null);
        return;
      }

      const data = await response.json();

      console.table(data.data);
      setResponse(data.data ?? {});
      setRefetch(false);
    };

    fetchData();
  }, [authContext.token, refetch]);

  const deletePostHandler = async (id) => {
    setIsLoading(true);
    try {
      const response = await fetch(process.env.REACT_APP_EXPRESS_URL + "/post/" + id, {
        headers: {
          Authorization: "Bearer " + authContext.token,
          "Content-Type": "application/json",
        },
        method: "DELETE",
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("linkedin-scheduler-token");
          return (window.location.href = "/login");
        }
        const error = await response.json();
        setDeleteApiResponse({ success: false, message: error.message });

        return;
      }

      const data = await response.json();
      setDeleteApiResponse({ success: true, message: data.message });
      setRefetch(true);

      // alert(data.message);
    } catch (error) {
      setDeleteApiResponse({
        success: false,
        message: "Something went wrong. Please try again.",
      });
    } finally {
      setIsLoading(false);
      setTimeout(() => {
        // setRefetch(true);
        closeAlert();
      },3000)
    }
  };

  const closeAlert = () => setDeleteApiResponse(null);

  return (
    <div className="min-h-screen text-white p-6 pt-26">
  {/* PAGE HEADER */}
  <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
    <h4 className="text-l font-semibold">Post</h4>
    <div className="text-l text-gray-400 md:mt-0">
      <button type="button" className="text-blue" onClick={() => navigate("/panel/dashboard")}>Home</button>
      <span> / Posts</span>
    </div>
  </div>

  {/* CARD */}
  <div className="bg-gray-800 rounded-lg shadow-lg overflow-hidden">
    <div className="flex items-center justify-between px-6 py-4 border-b border-gray-700 bg-gray-700">
      <h3 className="text-lg font-semibold text-white">List of Posts</h3>
      <div className="relative group inline-block">
  <i
    className="fas fa-plus text-white cursor-pointer hover:text-blue-400"
    onClick={() => navigate('/panel/post')}
  />
  <div className="absolute bottom-full left-1/2 transform -translate-x-[80%] mb-0 opacity-0 group-hover:opacity-100 transition-opacity bg-gray-700 text-white text-s px-2 py-1 rounded shadow-lg z-10 whitespace-nowrap">
    Create post
  </div>
</div>
    </div>

    {/* SUCCESS/ERROR ALERTS */}
    {deleteApiResponse && deleteApiResponse.success && (
    <div className="px-4 py-3 ml-4 mr-4 mt-3 rounded-lg bg-green-100 text-green-800 border border-green-300 text-sm relative transition-opacity duration-500 ease-in-out">
       {deleteApiResponse.message}
      <button
        onClick={closeAlert}
        className="absolute right-2 top-2 text-green-600 hover:text-green-800 text-l"
      >
        &times;
      </button>
    </div>)}

    {/* POST LIST */}
    <div className="p-6">
      {isLoading ? (
        <Loader />
      ) : response.length ? (
        response.map((post) => (
          <Post
            key={post._id}
            data={post}
            deletePost={deletePostHandler}
          />
        ))
      ) : (
        <div className="text-center text-gray-400">You have not created any post yet!</div>
      )}
    </div>
  </div>
</div>

  );
};

export default PostList;
